import styles from './support.module.scss';
import { Box, Container, ContractStatusEnum, OrderTypesEnum } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import { useGetRequestNewHook } from '../../requestUtils';
import PageTitle from '../../page-title/page-title';
import { useEffect, useState } from 'react';
import { UseSignalRHook } from '../../signalr-context/signalr-context';
import SupportGrid from '../support-grid/support-grid';
import BasicSupport from '../basic-support/basic-support';
import BasicSupportSkeleton from '../basic-support/basic-support-skeleton';
import SupportGridSkeleton from '../support-grid/support-grid-skeleton';
import { ICustomerSupportContracts } from '../../_models/customer-support-contracts';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface SupportProps { }

export function Support(props: SupportProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const companyNumber = currentCompany ? currentCompany.number : "";
  const { data: customerSupportContracts, getData, isLoading }: { data: ICustomerSupportContracts[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(`contracts/action/getSupportContracts/${companyNumber}/`, [], [currentCompany]);

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => setSelectedIndex(0), [companyNumber]);

  const onSignalRReceived = () => {
    console.log("SignalR received");
    getData();
  };

  UseSignalRHook(onSignalRReceived, [OrderTypesEnum.ChangeLicenseAccess]);
  const sortedContracts = customerSupportContracts && customerSupportContracts.sort((contract1, contract2) => {
    if (contract1.contractInfo.status === ContractStatusEnum.ACTIVE && contract2.contractInfo.status !== ContractStatusEnum.ACTIVE) return -1;
    if (contract1.contractInfo.status !== ContractStatusEnum.ACTIVE && contract2.contractInfo.status === ContractStatusEnum.ACTIVE) return 1;
    return 0;
  });

  const selectedContract: ICustomerSupportContracts = sortedContracts[selectedIndex];

  const handleNextUserClick = () => {
    const numberOfContracts = sortedContracts.length;
    const isLastContract = selectedIndex === (numberOfContracts - 1);
    setSelectedIndex(isLastContract ? 0 : selectedIndex + 1);
  };

  if (!selectedContract) {
    if (isLoading) {
      return (
        <Container
          className='container-fluid pt-4 px-0'
          maxWidth={false}
          sx={{ paddingBottom: '50px' }}>
          <Row>
            <Col>
              <Box
                component='div'
                className='pb-5'>
                <PageTitle title={t("app.userSupport")} showNoCompanyMessage={!currentCompany} />
                <BasicSupportSkeleton />
                <SupportGridSkeleton />
              </Box>
            </Col>
          </Row>
        </Container>
      );
    }
    return (
      <Container
        className='container-fluid pt-4 px-0'
        maxWidth={false}
        sx={{ paddingBottom: '50px' }}>
        <Row>
          <Col>
            <Box
              component='div'
              className='pb-5'>
              <PageTitle title={t("support.noUserSupportAgreement")} />
            </Box>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container
      className='container-fluid pt-4 px-0'
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component='div'
            className='pb-5'>
            <PageTitle title={t("app.userSupport")} showNoCompanyMessage={!currentCompany} />
            {!currentCompany && customerSupportContracts ?
              <BasicSupportSkeleton /> :
              <BasicSupport
                selectedContract={sortedContracts[selectedIndex]}
                numberOfContracts={customerSupportContracts.length}
                selectedContractIndex={selectedIndex + 1}
                onNextUserClick={handleNextUserClick}
              />}
            {!currentCompany ?
              <SupportGridSkeleton /> :
              <SupportGrid
                companyNumber={currentCompany.number}
                contractId={selectedContract.id}
                companyId={selectedContract.companyId}
                isGroupDeal={selectedContract.isGroupDeal}
                maxUsersOnContract={selectedContract.numberOfUsers}
                estimatedMinutesLeft={selectedContract.estimatedMinutesLeft}
                balance={selectedContract.balance}
                usersOnContract={selectedContract.usersOnContract}
                isLoading={isLoading}
              />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Support;